import { BaseDto } from "src/dtos/common/baseDto";
import { EquipmentDto } from "src/dtos/equipment/equipmentDto";
import { EqmInspectHisDto } from "src/dtos/eqmInspectHis/eqmInspectHisDto";
import { formatDate } from "src/utils/string/stringUtil";

/**
 * MST4030_R01 헤더 DTO
 * TOOLING 설비 정보 (EquipmentDto 확장)
 */
export interface MST4030_R01HeaderDto extends EquipmentDto {
	equipmentClass: string;			// 설비분류 (TOOLING)
	equipmentTypeNm: string;		// 설비유형명 (EQMTYPE 코드명)
	holdQty: number;					// 보유량
}

/**
 * MST4030_R01 디테일 DTO
 * 점검 이력 정보 (EqmInspectHisDto 확장)
 */
export interface MST4030_R01DetailDto extends EqmInspectHisDto {
	oldInspectDt?: string;
	oldEqmCd?: string;
	oldInspectCycle?: string;
	oldInspectType?: string;
	compNm: string;					// 사업장명 (조인)
	inspectTypeNm: string;			// 점검유형명 (조인)
}

/**
 * MST4030_R01 통합 DTO
 * 헤더와 디테일 리스트를 포함하는 통합 DTO
 */
export interface MST4030_R01Dto {
	headerDto: MST4030_R01HeaderDto;
	detailDtoList: MST4030_R01DetailDto[];
	listLength?: number;
	refetchListLength?: number;
	compCd?: string;
	workplaceCd?: string;
	equipmentType?: string;
	equipmentCd?: string;
	eqmCd?: string;
}

/**
 * 기본 MST4030_R01HeaderDto 값
 */
export const defaultMST4030_R01HeaderDto: MST4030_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	equipmentCd: '',
	equipmentNm: '',
	equipmentClass: 'TOOLING',
	equipmentSpec: '',
	eqmSerial: '',
	equipmentType: 'METALMASK',
	equipmentTypeNm: '',
	workplaceCd: '',
	equipmentSeq: 0,
	displaySeq: 0,
	compCd: '',
	compNm: '',
	eqmOrgcd: '',
	eqmOrgNm: '',
	eqmPerson: '',
	eqmPersonNm: '',
	holdQty: 0,
	eqmPower: 0,
	eqmVolt: 0,
	sizeHeight: 0,
	sizeWidth: 0,
	sizeDepth: 0,
	sizeWeight: 0,
	otherSpec: '',
	manufacturerNm: '',
	manufactureDt: formatDate(new Date()),
	purchaseNm: '',
	purchaseDt: formatDate(new Date()),
	purchaseAmt: 0,
	linkIp: '',
	linkPort: '',
	gatheringCycle: 0,
	instrucTag: '',
	virtualEqm: '',
	eqmImage: '',
	eqmImage2: '',
	eqmStatus: '',
	eqmStatusNm: '',
	disposalDt: formatDate(new Date()),
	remark: '',

	inserted: false,
	isModified: false,

	insertDt: new Date(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: ''
}

/**
 * 기본 MST4030_R01DetailDto 값
 */
export const defaultMST4030_R01DetailDto: MST4030_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectDt: formatDate(new Date()),
	eqmCd: '',
	inspectCycle: '',
	inspectType: '',
	inspectTypeNm: '',
	compCd: '',
	compNm: '',
	inspectMethod: '',
	inspectPart: '',
	inspectAction: '',
	resultAction: '',
	inspectTime: '',
	transportQty: 0,
	inspectEmpno: '',
	inspectEmpNm: '',
	remark: '',

	inserted: false,
	isModified: false,

	insertDt: new Date(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: ''
}
